export default __webpack_public_path__ + "static/media/auth-google.86c3d97d.svg";